import {CifAddressInfoModel} from '../../../../../personal/model/SaveClientModels/cif-address-info.model';

export class CifVehicleAddressModel extends CifAddressInfoModel {

    areaTypeCode: string;
    storageTypeCode: string; // Mandatory
    sameAsHome: boolean; // Mandatory - if false the inherited address fields are required

}
